<EfisNotification v-if="user?.id &amp;&amp; isShowEfisReportNotification" @close="closeEfisNotification"></EfisNotification>